import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import MaterialTable from "material-table";
import UiUtils from "../../../provider/UiUtils";
import AdminFetchServerData from "../../../provider/AdminFetchServerData";
import store from "../../../redux/store";
import AdminMenuWithBreadScrum from "../adminMenu/AdminMenuWithBreadScrum";
import Utils from "../../../provider/Utils";

class PlanAccountList extends Component {
  header = store.getState().adminHeader.adminHeader;
  breadCrumb = [
    { pageid: "/planList", uiname: "Plan List" },
    { pageid: "", uiname: "Account List" },
  ];
  constructor(props) {
    super(props);
    let planId = props.planId;
    let planName = props.planId;
    let businessDomain = props.businessDomain;
    let businessType = props.businessType;
    let businessUseCase = props.businessUseCase;
    if (props.state) {
      planId = props.state.planId;
      planName = props.state.planName;
      businessDomain = props.state.businessDomain;
      businessType = props.state.businessType;
      businessUseCase = props.state.businessUseCase;
    }

    if (null !== planId && planId > 0) {
      this.getAccountListForPlan(planId);
    }
    this.state = {
      initialPage: 0,
      pageSize: 10,
      planName: planName,
      businessDomain: businessDomain,
      businessType: businessType,
      businessUseCase: businessUseCase,
      planAccountList: [],
      isPaging: false,
      render: false,
    };
  }

  getAccountListForPlan(planId) {
    const postObject = {
      header: this.header,
      planId: planId,
    };

    AdminFetchServerData.callPostService(
      "/apAccountms/getListForPlan",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let planAccountList = output.data.accountList;
        let isPaging = false;
        if (planAccountList.length > this.state.pageSize) {
          isPaging = true;
        }

        for (let i = 0; i < planAccountList.length; i++) {
          planAccountList[i].subscriptionStartdate = Utils.getUtcToLocal(
            planAccountList[i].subscriptionStartdate
          );
          planAccountList[i].subscriptionEnddate = Utils.getUtcToLocal(
            planAccountList[i].subscriptionEnddate
          );
        }

        this.setState({
          render: true,
          isPaging: isPaging,
          planAccountList: planAccountList,
        });
      } 
    });
  }

  viewCancel() {
    this.props.navigate("/planList", {
      state: {
        action: "view",
        businessDomain: this.state.businessDomain,
        businessType: this.state.businessType,
        businessUseCase: this.state.businessUseCase,
      },
    });
  }

  render() {
    if (this.state.render === false) {
      return <div />;
    }
    return (
      <>
        <AdminMenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          history={this.props.history}
          name={this.state.planName}
          businessDomain={this.state.businessDomain}
          businessType={this.state.businessType}
          businessUseCase={this.state.businessUseCase}
          backCallback={this.viewCancel.bind(this)}
          pageId="viewPage"
        />
        <div style={{ maxWidth: "100%" }}>
          <MaterialTable
            title=""
            icons={UiUtils.getMaterialTableIcons()}
            localization={{
              body: {
                emptyDataSourceMessage: <h5>Please add account</h5>,
              },
            }}
            columns={[
              {
                title: "#",
                render: (rowData) => rowData.tableData.id + 1,
                width: "5%",
                align: "left",
                cellStyle: {
                  width: "6%",
                },
              },
              {
                title: "Company Name",
                field: "tenantName",
                cellStyle: {
                  width: "20%",
                },
              },
              {
                title: "Type",
                field: "subscriptionType",
                cellStyle: {
                  width: "20%",
                },
              },
              {
                title: "Start Date",
                field: "subscriptionStartdate",
                cellStyle: {
                  width: "20%",
                },
              },
              {
                title: "End Date",
                field: "subscriptionStartdate",
                cellStyle: {
                  width: "20%",
                },
              },
              {
                title: "Price",
                render: (rowData) =>
                  `${rowData?.currency}${rowData?.planPrice}`,
                cellStyle: {
                  width: "20%",
                },
              },
              {
                title: "status",
                field: "subscriptionStatus",
                cellStyle: {
                  width: "20%",
                },
              },
            ]}
            data={this.state.planAccountList}
            options={{
              sorting: true,
              actionsColumnIndex: -1,
              initialPage: this.state.initialPage,
              pageSize: this.state.pageSize,
              pageSizeOptions: [5, 10, 20, 50, 100],
              paging: this.state.isPaging,
              headerStyle: {
                backgroundColor: "#37517e",
                fontWeight: "bold",
                color: "#ffff",
                align: "left",
              },
            }}
          />
        </div>
      </>
    );
  }
}
export default withRouter(PlanAccountList);
